import ButtonAddToCart from '@components/ButtonAddToCart';
import {
  getIsAntiWaste,
  getMaxQuantity,
  getMinimumProductQuantity,
} from '@monofront/business/utils';
import AddCart from '@monofront/design-system/visuals/Icons/Old/AddCart';
import { AddToShoppingCartSource, IProduct } from '@monofront/types';
import { useTranslations } from 'next-intl';

interface IProductAddToCartProps {
  product: IProduct;
}

const ProductAddToCart: React.FC<IProductAddToCartProps> = ({ product }) => {
  const maxQuantity = getMaxQuantity(product);
  const isAntiWaste = getIsAntiWaste(product.tags);
  const tCart = useTranslations('Cart');
  const addLabel = tCart('addToCartConfirm2');
  const minimumQuantity = getMinimumProductQuantity(product.tags);

  return (
    <ButtonAddToCart
      shoppingCartProduct={product}
      max={maxQuantity}
      size="large"
      hasEditViewOnly={true}
      isDisabled={
        (isAntiWaste && product.inventory_quantity <= 0) ||
        minimumQuantity > product.inventory_quantity
      }
      containerContext={{ source: AddToShoppingCartSource.DEFAULT }}
      UNSAFE_className={addLabel.length > 10 ? '' : 'tw-px-7'}
    >
      <>
        <AddCart width={24} height={24} />
        <span className={addLabel.length > 10 ? 'tw-text-[15px]' : ''}>
          {addLabel}
        </span>
      </>
    </ButtonAddToCart>
  );
};

export default ProductAddToCart;
